/**
 * Brand Configuration
 *
 * Owner values read from environment variables. Mutable content (WhatsApp, email,
 * NIB, address) may be empty at launch; components use hasX boolean helpers to
 * hide blocks entirely when empty, not render dummy links.
 *
 * Immutable display names live here so they're not typed raw in 38 screens.
 * Nomor rekening does NOT belong here — it comes from GET /ecommerce/payments/{code}
 * so only the person paying sees it.
 */

interface BrandConfig {
  // Display names (immutable)
  displayName: string;
  productName: string;

  // Owner contact (mutable, may be empty)
  whatsappUrl: string | null;
  messengerUrl: string | null;
  adminHours: string | null;

  // Owner legal info (mutable, may be empty)
  businessNib: string | null;
  businessAddress: string | null;

  // Helpers: return true if value exists and is non-empty
  hasWhatsapp: boolean;
  hasMessenger: boolean;
  hasAdminHours: boolean;
  hasBusinessNib: boolean;
  hasBusinessAddress: boolean;
}

function getEnvString(key: string): string | null {
  const value = (import.meta.env[key] as string) || '';
  return value.trim() ? value : null;
}

export const brand: BrandConfig = {
  // Display names
  displayName: 'Lapak Bang Ade',
  productName: 'Jualan',

  // Owner contact
  whatsappUrl: getEnvString('VITE_WHATSAPP_URL'),
  messengerUrl: getEnvString('VITE_MESSENGER_URL'),
  adminHours: getEnvString('VITE_ADMIN_HOURS'),

  // Owner legal info
  businessNib: getEnvString('VITE_BUSINESS_NIB'),
  businessAddress: getEnvString('VITE_BUSINESS_ADDRESS'),

  // Helpers
  get hasWhatsapp() {
    return this.whatsappUrl !== null;
  },
  get hasMessenger() {
    return this.messengerUrl !== null;
  },
  get hasAdminHours() {
    return this.adminHours !== null;
  },
  get hasBusinessNib() {
    return this.businessNib !== null;
  },
  get hasBusinessAddress() {
    return this.businessAddress !== null;
  },
};

// Freeze to prevent accidental modification
Object.freeze(brand);

export default brand;
